<template>
  <div class="card-form">
    <PageMain
      :multiple="multiple"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :tableHeight="tableHeight"
      :reserve="reserve"
      :highlight="highlight"
      @reload="reload"
      @chooseChange="chooseChange"
    >
      <template #header>
        <PageHeader
          ref="header"
          @query="getData"
          @reset="resetPage"
          :checkedCount="checkedCount"
        />
      </template>
      <template #pager>
        <pagination
          size="small"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
    </PageMain>
  </div>
</template>

<script>
import BaseTable from "@/mixins/base-table";
import PageMain from "./Table.vue";
import PageHeader from "./Header.vue";

export default {
  components: {
    PageMain,
    PageHeader,
  },
  mixins: [BaseTable],
  props: {
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: true },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 800 },
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      usePage: true,
    };
  },
  methods: {
    getData(form) {
      this.loading = true;
      this.$api
        .sysUserList({ ...form, ...this.page })
        .then((res) => {
          this.loading = false;
          this.setData(res);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    chooseChange(e) {
      this.$emit("chooseChange", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-form {
  padding: 10px;
}
</style>
